export enum Theme {
  DARK = 'dark',
  HACKER_THEME = 'hacker_theme',
  BLACK = 'black',
}

export const darkThemeToClassMap = {
  [Theme.DARK]: 'dark-app-theme',
  [Theme.HACKER_THEME]: 'hacker_theme-app-theme',
  [Theme.BLACK]: 'black-app-theme',
};

export const darkThemeValues = Object.keys(darkThemeToClassMap);
export const darkThemeClasses = Object.values(darkThemeToClassMap);
